(ns ui.editors.card.property-list.model
  (:require
   [common.localization :as loc]
   [ui.editors.card.model :as common-model]))

(def empty-cell
  {:field nil
   :always-visible? true
   :empty-cell-value ""
   :width 1})

(def card-rows-path (conj common-model/card-config-path :rows))

(def card-rows-full-path (vec (concat common-model/root-path card-rows-path)))

(def all-cell-validation-errors-path (conj common-model/validation-error-path :cell-validation-errors))
(def all-cell-validation-errors-full-path (vec (concat common-model/root-path all-cell-validation-errors-path)))

(defn ->cell-validation-error-path
  [row-index cell-index]
  (vec (concat all-cell-validation-errors-path [row-index cell-index])))

(defn ->cell-validation-error-full-path
  [row-index cell-index]
  (vec (concat all-cell-validation-errors-full-path [row-index cell-index])))

(defn ->cell-validation-error-missing-field-full-path
  [row-index cell-index]
  (conj (->cell-validation-error-full-path row-index cell-index) :missing-field?))

(defn get-rows-db
  [db]
  (get-in db card-rows-full-path))

(defn get-row-db
  [db row-index]
  (let [rows (get-rows-db db)
        row (nth rows row-index)]
    row))

(defn get-cell-db
  [db row-index cell-index]
  (let [row (get-row-db db row-index)
        cell (nth row cell-index)]
    cell))

(defn get-cell-validation-errors-db
  [db row-index cell-index]
  (get-in db (->cell-validation-error-full-path row-index cell-index)))

(defn set-cell-validation-errors-db
  [db row-index cell-index validation-errors]
  (assoc-in db (->cell-validation-error-full-path row-index cell-index) validation-errors))

(defn set-rows-db
  [db rows]
  (assoc-in db card-rows-full-path rows))

(defn set-row-db
  [db row-index new-row]
  (let [prev-rows (get-rows-db db)
        new-rows (->> prev-rows
                      (map-indexed (fn [idx prev-row]
                                     (if (= idx row-index)
                                       new-row
                                       prev-row)))
                      (vec))]
    (set-rows-db db new-rows)))

(defn set-cell-property-db
  [db row-index cell-index property value]
  (let [prev-row (get-row-db db row-index)
        prev-cells (:cells prev-row)
        new-cells (->> prev-cells
                       (map-indexed
                        (fn [idx cell]
                          (if (= idx cell-index)
                            (assoc cell property value)
                            cell)))
                       (vec))
        new-row (assoc prev-row :cells new-cells)]
    (set-row-db db row-index new-row)))

(defn set-cell-width-db
  [db row-index cell-index new-width]
  (set-cell-property-db db row-index cell-index :width new-width))

;; Todo do this with malli schema once requirements are clear?
(defn validate-card
  [card]
  (let [rows (get-in card [:card/config :rows])
        cells (->> rows
                   (mapcat :cells))
        no-cells? (empty? cells)
        cell-validation-errors
        (->> rows
             (map-indexed
              (fn [row-index row]
                [row-index row]))
             (keep (fn [[row-index row]]
                     (let [cells (:cells row)
                           cell-errors
                           (->> cells
                                (map-indexed
                                 (fn [cell-index cell]
                                   [cell-index cell]))
                                (keep (fn [[cell-index cell]]
                                        (when-not (:field cell)
                                          [cell-index {:missing-field? true}])))
                                (into {}))]
                       (when (seq cell-errors)
                         [row-index cell-errors]))))
             (into {}))
        errors? (or no-cells? (seq cell-validation-errors))
        message (cond
                  no-cells?
                  (loc/tr :card-editor/property-list-add-at-least-one-field)
                  (seq cell-validation-errors)
                  (loc/tr :card-editor/property-list-missing-fields-helper)
                  :else nil)]
    (when errors?
      {:message message
       :cell-validation-errors cell-validation-errors})))
